<ng-container *ngIf="isShowingResults === false">
  <div class="group-container">
    <div class="group-wrap">
      <div class="titles" *ngIf="_card.legend1 || _card.text1">
        <div class="group-title" *ngIf="_card.legend1">{{ _card.legend1 }}</div>
        <div class="group-subtitle" *ngIf="_card.text1">{{ _card.text1 }}</div>
      </div>
    </div>

    <div class="group-wrap">
      <div class="titles" *ngIf="_card.legend2 || _card.text2">
        <div class="group-title" *ngIf="_card.legend2">{{ _card.legend2 }}</div>
        <div class="group-subtitle" *ngIf="_card.text2">{{ _card.text2 }}</div>
      </div>
    </div>

    <div class="group-wrap group-wrap-2x">
      <div *ngFor="let pair of pairs; let i = index"
           class="group-2x"
           [ngClass]="{
              'completed': isSubmitted,
              'paired': pair.isPaired
              }">
        <div cdkDrag
             (cdkDragMoved)="onMoved($event, i)"
             (cdkDragStarted)="onDropStarted($event, i)"
             (cdkDragEnded)="onDropEnded($event, i)"
             [cdkDragDisabled]="isSubmitted"
             [cdkDragFreeDragPosition]="dragPosition[i]"
             class="item item-left"
             [ngClass]="{
               'neutral': isSubmitted && _card.isNoCorrect,
               'correct': isSubmitted && !_card.isNoCorrect && pair.question.item.id === pair.answer.item.id,
               'wrong': isSubmitted && !_card.isNoCorrect && pair.question.item.id !== pair.answer.item.id
         }">
          <img *ngIf="!isSubmitted" src="/images/conference/drag.svg">
          {{ pair.question.item.text }}
        </div>
        <div class="item item-right" [ngClass]="{
          'neutral': isSubmitted && _card.isNoCorrect,
          'correct': isSubmitted && !_card.isNoCorrect && pair.question.item.id === pair.answer.item.id,
          'wrong': isSubmitted && !_card.isNoCorrect && pair.question.item.id !== pair.answer.item.id
         }">
          {{ pair.answer.item.textAnswer }}
        </div>
      </div>
    </div>
  </div>

  <app-card-button *ngIf="!isSubmitted && isPaired()"  [text]="'__INTERACTION_SUBMIT_RESPONSE__' | translate"
                   (onSubmit)="submit()"></app-card-button>

</ng-container>

<ng-container *ngIf="isShowingResults === true && results">
  <app-card-results [results]="results"></app-card-results>
  <app-card-button *ngIf="isEnableSwitchViews"
                   (click)="hideResults()" [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_MY_ANSWERS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
